import React, { useState, useEffect, useContext } from 'react'
import { getAllBreatheForPublic } from 'src/consumer/services/featureServices'
import useInfiniteScroll from 'react-infinite-scroll-hook'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import { APP_CONSTANTS } from 'src/consumer/constants'
import { LoadingSpinner } from '../Loaders'
import PublicAppHeader from '../PublicAppHeader'
import { PublicListingComponentVarOne } from '../ListingPageComponentsAndHelpers/ListingPageComponents'
import { GenericInformationModal } from '../GenericInformationModal'
import { InformationContext } from 'src/consumer/context/InformationContext'
import { getListItemsFromBreatheList } from '../ListingPageComponentsAndHelpers/ListingPageHelpers'

export default function BreatheListingPage() {
  const [pageLoading, setPageLoading] = useState(false)
  const [breatheList, setBreatheList] = useState()

  const [pageNumber, setPageNumber] = useState(1)
  const [hasNextPage, setHasNextPage] = useState(true)

  const { informationModalData, setInformationModalData } = useContext(InformationContext)

  async function pageSetup() {
    setPageLoading(true)
    const resp = await getAllBreatheForPublic()
    if (resp?.status === 200) {
      setBreatheList(resp?.data)
    }
    setPageLoading(false)
  }

  async function getNextBreathePage() {
    const nextPageNumber = pageNumber + 1

    const resp = await getAllBreatheForPublic(nextPageNumber)

    if (resp?.status === 200) {
      if (resp?.data && resp?.data?.length > 0) {
        setPageNumber(nextPageNumber)
        setBreatheList((prev) => [...prev, ...resp?.data])
      } else {
        // If there's no more data to load, set hasNextPage to false
        setHasNextPage(false)
      }
    } else {
      setHasNextPage(false)
    }
  }

  const [sentryRef] = useInfiniteScroll({
    hasNextPage,
    onLoadMore: getNextBreathePage,
    rootMargin: '0px 0px 20px 0px',
  })

  useEffect(() => {
    pageSetup()
  }, [])

  return (
    <>
      <SEOComponent
        title="Breathe | AUMHUM"
        description="Explore Breathe"
        image={APP_CONSTANTS.APP_LOGO_LINK}
      />
      {pageLoading ? (
        <LoadingSpinner bgColor="#F5F5F599" dark />
      ) : (
        <>
          <PublicAppHeader config={{ showLinks: true }} />
          <PublicListingComponentVarOne
            heading="Explore Breathe"
            description="Explore Breathe"
            actionText="Start"
            listItemsArray={getListItemsFromBreatheList(breatheList)}
            sentryRef={sentryRef}
            hasNextPage={hasNextPage}
            onClickOverride={() =>
              setInformationModalData({ showModal: true, data: { toShow: 'app_exclusive' } })
            }
          />
          {informationModalData?.showModal && <GenericInformationModal />}
        </>
      )}
    </>
  )
}
